// Local Deps
import { makeGraphQLRequest } from '../../../utils/requestUtils';

/*-----------------------
    REQUEST USER ID
-------------------------*/
export async function requestUserById(id) {
  // Format Query
  const query = `query requestUserById(
    $id: ID
  ) {
      user(id: $id) {
        name
        email
        phoneNumber
        email
        faxNumber
        iconStatus
        role
        organizationId
        permissions
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

/*-----------------------
    UPDATE USER
-------------------------*/
export async function updateUser(user) {
  // Format Mutation
  const query = `mutation updateUser(
    $user: EditUserInput
  ) {
    updateUser (user: $user) {
      name,
      email,
      role,
      organizationId
    }
  }`;

  // Variables
  const variables = { user };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/components/Modals/EditUser/graphql.js